


































import { Vue, Component } from "vue-property-decorator";
import ProductRow from "@/components/my-routine/ProductRow.vue";
import ProductTable from "@/components/my-routine/ProductTable.vue";
import AddButton from "@/components/my-routine/AddButton.vue";
import AddProductPopup from "@/components/my-routine/AddProductPopup.vue";
import EditProductPopup from "@/components/my-routine/EditProductPopup.vue";
import FullScreenLoading from "@/components/FullScreenLoading.vue";
import AlertError from "@/components/AlertError.vue";
import AlertSuccess from "@/components/AlertSuccess.vue";
import MyRoutineController from "@/controller/my-routine-products";
import { Product } from "@/controller/my-routine-products";

const SERVER_ERROR_MESSAGE = "Lỗi hệ thống, vui lòng thử lại sau";
const PRODUCT_EXISTS_MESSAGE = "Mã sản phẩm đã tồn tại";

const controller = new MyRoutineController();

const emptyProduct: Product = {
  step: "",
  product_url: "",
  haravan_product_id: "",
  categories: [],
  name: "",
  description: "",
  image_url: ""
};

@Component({
  components: {
    ProductRow,
    ProductTable,
    AddButton,
    FullScreenLoading,
    AlertError,
    AlertSuccess,
    AddProductPopup,
    EditProductPopup
  }
})
export default class MyRoutineProducts extends Vue {
  products: Product[] = [];
  loading = false;
  errorMessage = "";
  showAddProductPopup = false;
  isAddingProductSuccessful = false;
  showEditProductPopup = false;
  productInEditing: Product = emptyProduct;

  async mounted() {
    this.loading = true;
    this.products = await controller.getProducts();
    this.loading = false;
  }

  get isError(): boolean {
    return this.errorMessage !== "";
  }

  set isError(value: boolean) {
    this.errorMessage = "";
  }

  get step1Products(): Product[] {
    return this.products.filter(product => product.step === "1");
  }

  get step2Products(): Product[] {
    return this.products.filter(product => product.step === "2");
  }

  get step3Products(): Product[] {
    return this.products.filter(product => product.step === "3");
  }

  get recommendProducts(): Product[] {
    return this.products.filter(product => product.step === "recommend");
  }

  get displayProducts() {
    return [
      {
        title: "Bước 1",
        products: this.step1Products
      },
      {
        title: "Bước 2",
        products: this.step2Products
      },
      {
        title: "Bước 3",
        products: this.step3Products
      },
      {
        title: "Đặc trị khuyên dùng",
        products: this.recommendProducts
      }
    ];
  }

  async deleteProduct(product: Product) {
    const productIndex = this.findProductIndex(product);
    this.products.splice(productIndex, 1);
    await this.updateProductsToServer();
  }

  private findProductIndex(product: Product): number {
    return this.products.findIndex(
      p => p.haravan_product_id === product.haravan_product_id
    );
  }

  private async updateProductsToServer() {
    this.loading = true;

    try {
      await controller.updateProducts(this.products);
    } catch (error) {
      this.showErrorMessage(SERVER_ERROR_MESSAGE);
    } finally {
      this.loading = false;
    }
  }

  private showErrorMessage(message: string) {
    this.errorMessage = message;
    this.scrollToTop();
  }

  private scrollToTop() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  }

  showEditPopup(product: Product) {
    this.updateProductInEditing(product);
    this.showEditProductPopup = true;
  }

  private updateProductInEditing(product: Product) {
    for (const key in product) {
      this.$set(this.productInEditing, key, product[key as keyof Product]);
    }
  }

  async editProduct(product: Product) {
    const productIndex = this.findProductIndex(product);
    this.products.splice(productIndex, 1, product);
    this.showEditProductPopup = false;
    await this.updateProductsToServer();
  }

  async addProduct(product: Product) {
    if (this.productExists(product)) {
      this.showErrorMessage(PRODUCT_EXISTS_MESSAGE);
      this.showAddProductPopup = false;
      return;
    }

    this.products.push(product);
    await this.updateProductsToServer();
    this.toastAddingProductSuccessful();
  }

  private productExists(product: Product): boolean {
    return this.findProductIndex(product) > -1;
  }

  private toastAddingProductSuccessful() {
    this.isAddingProductSuccessful = true;

    setTimeout(() => {
      this.isAddingProductSuccessful = false;
    }, 2000);
  }
}
